"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTimeout = exports.TimeoutError = void 0;
const asAbortable_1 = require("./asAbortable");
class TimeoutError extends Error {
    constructor(timeoutInMs, customErrorContext) {
        super(customErrorContext === undefined
            ? `timed out after ${timeoutInMs} ms`
            : `${customErrorContext} (timed out after ${timeoutInMs} ms)`);
        this.code = 'TimeoutError';
    }
}
exports.TimeoutError = TimeoutError;
const withTimeout = (task, timeoutInMs, customErrorContext, abortSignal) => {
    let timeoutRef;
    return (0, asAbortable_1.asAbortable)(Promise.race([
        task,
        new Promise((_resolve, reject) => {
            timeoutRef = setTimeout(() => {
                reject(new TimeoutError(timeoutInMs, customErrorContext));
            }, timeoutInMs);
        })
    ]), abortSignal, customErrorContext).finally(() => {
        clearTimeout(timeoutRef);
    });
};
exports.withTimeout = withTimeout;
//# sourceMappingURL=withTimeout.js.map